export default "__VITE_ASSET__CDs7r9Pk__"